import { Link } from "react-router";

export function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex items-center justify-center"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-0 -z-10 w-full bg-gradient-to-b from-background via-secondary to-secondary" />
        <picture>
          <source
            type="image/avif"
            srcSet="/hero-bg-768.avif 768w, /hero-bg.avif 1536w"
            sizes="100vw"
          />
          <source
            type="image/webp"
            srcSet="/hero-bg-768.webp 768w, /hero-bg.webp 1536w"
            sizes="100vw"
          />
          <img
            src="/hero-bg.webp"
            alt=""
            aria-hidden="true"
            width={1536}
            height={1024}
            fetchPriority="high"
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover mix-blend-normal opacity-40 pointer-events-none select-none"
          />
        </picture>
      </div>
      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col items-center justify-center text-center min-h-[600px]">
          <div className="flex w-auto items-center space-x-2 rounded-full px-4 py-1.5 ring-1 ring-border bg-card whitespace-pre mb-8">
            <span className="text-xs font-medium text-muted-foreground sm:text-sm">
              KI für das Vergabewesen
            </span>
          </div>
          <div className="flex w-full max-w-4xl flex-col items-center overflow-hidden">
            <h1 className="text-center text-4xl font-semibold leading-tight text-[#111] sm:text-5xl md:text-6xl text-balance">
              KI-gestützte Qualitätssicherung für Ihre Vergabedokumente
            </h1>
            <p className="text-center max-w-xl leading-normal text-muted-foreground sm:text-lg sm:leading-normal text-balance mt-6">
              stapel.ai prüft Ihre Leistungsbeschreibungen automatisch auf
              Fehler, Unklarheiten und Compliance-Risiken, bevor sie
              veröffentlicht werden.
            </p>
          </div>
          <div className="relative mt-8">
            <Link to="/demo">
              <button className="inline-flex shrink-0 items-center justify-center rounded-lg border border-transparent text-sm font-medium whitespace-nowrap transition-all outline-none select-none active:translate-y-px bg-primary text-primary-foreground h-10 gap-1.5 px-5 cursor-pointer hover:bg-primary/90">
                Demo anfragen
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
